var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isButtonShown)?_c('a',{staticClass:"feedback-btn",attrs:{"href":_vm.feedbackLink,"target":"_blank"},on:{"click":_vm.hideButton}},[_vm._v(" Feedback ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }